export function BrandMark({ size = "md" }: { size?: "sm" | "md" | "lg" }) {
  return (
    <span className={`brand-mark brand-mark--${size}`} aria-hidden="true">
      <img src="/brand/cafe-kalimashada.svg" alt="" />
    </span>
  );
}
